<div *ngIf="loading" class="spinner">
  <mat-spinner></mat-spinner>
</div>
<div
  [ngClass]="loading ? 'content-hidden' : 'content-show'"
  style="display: block"
  *ngIf="lineChartData.length > 0"
>
  <header class="header">
    <h2
      style="
        color: var(--material-theme-ref-neutral-neutral-20, #323033);
        font-family: Roboto;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        padding: 16px 32px;
      "
      class="card-title"
    >
      Casos por mês
    </h2>
  </header>
  <canvas
    style="width: 300px !important"
    id="myHChart2"
    baseChart
    [datasets]="lineChartData"
    [colors]="lineChartColors"
    [labels]="lineChartLabels"
    [chartType]="lineChartType"
    [options]="options"
  ></canvas>
  <div
    class="d-flex align-items-center justify-content-center"
    style="width: 100%"
  >
    <div *ngFor="let yearLabel of yearsLabels" class="year-label">
      <div class="color-label" [style.backgroundColor]="yearLabel.color"></div>
      {{ yearLabel.year }}
    </div>
  </div>
</div>
<div
  [ngClass]="loading ? 'content-hidden' : 'content-show no-data'"
  *ngIf="lineChartData.length == 0 || !lineChartData"
>
  Não há dados suficientes para gerar o gráfico.
</div>
